import type { FormFieldConfig } from '../components/common/FormField';

/**
 * `loan_comps.loan_type` is free text (NOT NULL) in the backend with no reference
 * table or API list. These are the values the Market Tracker seed data uses
 * (10fifty-genesis-api migrations/2026_05_27_replace_loan_comps_market_tracker.sql).
 */
export const LOAN_COMP_TYPES: string[] = [
  'Stabilised Loans',
  'Transitional Loans',
  'Development Loans',
];

/** Fields that must be filled before a loan comp can be created or updated. */
export const LOAN_COMP_REQUIRED_FIELDS: string[] = ['loan_type'];

export const loanCompFieldConfig: {
  section: string;
  columns: number;
  column: number;
  fields: FormFieldConfig[];
}[] = [
  {
    section: 'Loan Comp Details',
    columns: 2,
    column: 0,
    fields: [
      { field: 'loan_type', label: 'Loan Type', type: 'select', optionsKey: 'loanTypes', isStringArray: true },
      { field: 'date', label: 'Date', type: 'date' },
      { field: 'project_name', label: 'Project Name', type: 'text' },
      { field: 'sponsor', label: 'Sponsor', type: 'text' },
      { field: 'country', label: 'Country', type: 'select', optionsKey: 'countries', optionLabelKey: 'nicename' },
      { field: 'city', label: 'City', type: 'text' },
      { field: 'sector', label: 'Sector', type: 'select', optionsKey: 'sectors', optionLabelKey: 'sector' },
      { field: 'lender_type', label: 'Lender Type', type: 'text' },
      { field: 'loan_amount_local', label: 'Loan Amount (Local)', type: 'number', formatNumber: true },
      { field: 'ltc_ltv', label: 'LTC/LTV (%)', type: 'number' },
      { field: 'margin', label: 'Margin (%)', type: 'number' },
      { field: 'irr', label: 'IRR (%)', type: 'number' },
      { field: 'est_local_irr', label: 'Est. Local IRR (%)', type: 'number' },
    ],
  },
  {
    section: 'Notes',
    columns: 1,
    column: 0,
    fields: [
      { field: 'comment', label: 'Comment', type: 'multiline' },
    ],
  },
];
